import { z } from 'zod';
import { shiftParticipantHoursHistoryStatus } from '../entities/shiftParticipantHoursHistoryTypes';
export const shiftParticipantRowSchema = z.object({
    id: z.string().uuid(),
    created: z.number(),
    createdBy: z.string().uuid(),
    updated: z.number(),
    updatedBy: z.string().uuid(),
    parentId: z.string().uuid().optional(),
    columns: z.any(), // TODO: Change to use Zod typed columns after PLAT-2704
    permissions: z.string().array().optional(), // TODO: Change to required - CRMS-3034
});
export const shiftParticipantCsvRowSchema = z.object({
    ['FIRST_NAME']: z.string().optional(),
    ['LAST_NAME']: z.string().optional(),
    ['EMAIL']: z.string().email(),
    ['POSITION']: z.string(),
    ['STATUS']: z.enum(shiftParticipantHoursHistoryStatus),
    ['HOURS']: z.string().optional(),
});
export const shiftParticipantCsvMetadataSchema = z.object({
    shiftId: z.string(),
});
